import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useTheme } from '../context/ThemeContext';
import { BRAND } from '../copy/product';
import './MarketingNav.css';

export default function MarketingNav() {
  const { currentUser } = useAuth() || {};
  const { isDark, toggleTheme } = useTheme();
  return (
    <nav className="marketing-nav" aria-label="Main navigation">
      <div className="marketing-nav-inner">
        <Link to="/" className="marketing-brand"><img src={`${process.env.PUBLIC_URL}/logo-64.png`} width="28" height="28" alt="" />{BRAND}</Link>
        <div className="marketing-nav-links">
          <Link to="/#how-it-works">How it works</Link>
          <NavLink to="/extension">Extension</NavLink>
          {/* On a phone the visitor bar above already offers Pricing. */}
          <NavLink to="/pricing" className="marketing-nav-dup">Pricing</NavLink>
          <Link to="/#faq">FAQ</Link>
        </div>
        <div className="marketing-nav-actions">
          <button type="button" onClick={toggleTheme} aria-label="Toggle theme"><span className="material-symbols-rounded" aria-hidden="true">{isDark ? 'light_mode' : 'dark_mode'}</span></button>
          {currentUser ? <Link className="marketing-start" to="/dashboard">Open workspace</Link> : <><Link to="/login">Log in</Link><Link className="marketing-start" to="/register">Start free</Link></>}
        </div>
      </div>
    </nav>
  );
}
